import { useNavigate } from "react-router-dom";
import logo from "../../assets/logo.png";

const Navbar = ({ menus, info, dropdown }) => {
  const navigate = useNavigate();
  const handleGo = () => {
    if (!info || info.role === "admin" || info.role === "teacher") {
      return navigate("/");
    }
    return navigate(`/${info.role}`);
  };
  return (
    <div className="navbar bg-colorful shadow-md">
      <div className="flex-1">
        <button
          className="btn btn-ghost normal-case text-accent p-0"
          onClick={handleGo}
        >
          <img src={logo} alt="THE MAKER" className="mix-blend-screen" />
        </button>
      </div>
      <div className="relative dropdown-end">
        {info && menus && menus.length > 0 && (
          <>
            <div className="dropdown block md:hidden">
              <label tabIndex={0} className="btn btn-ghost btn-circle">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5 text-white rotate-180"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M4 6h16M4 12h16M4 18h7"
                  />
                </svg>
              </label>
              <ul
                tabIndex={0}
                className="menu menu-compact dropdown-content mt-3 p-2 shadow rounded-box w-32 bg-white"
              >
                {menus.map(({ key, list }) =>
                  list.map(({ label, to }) => (
                    <li key={key}>
                      <button
                        className="btn-link font-bold no-underline m-auto"
                        onClick={() => navigate(to)}
                      >
                        {label}
                      </button>
                    </li>
                  ))
                )}
              </ul>
            </div>
            <ul className="menu menu-horizontal px-1 hidden md:flex">
              {menus.map(({ key, list }) => (
                <li key={key}>
                  {list.map(({ label, key, to }) => (
                    <button
                      key={key}
                      className="btn-link text-primary font-bold no-underline mix-blend-color-dodge"
                      onClick={() => navigate(to)}
                    >
                      {label}
                    </button>
                  ))}
                </li>
              ))}
            </ul>
          </>
        )}
        {info && dropdown && (
          <div className="dropdown dropdown-end">
            <label
              tabIndex={0}
              className="btn btn-circle mix-blend-color-dodge hidden md:flex"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="w-6 h-6"
              >
                <path
                  fillRule="evenodd"
                  d="M18.685 19.097A9.723 9.723 0 0021.75 12c0-5.385-4.365-9.75-9.75-9.75S2.25 6.615 2.25 12a9.723 9.723 0 003.065 7.097A9.716 9.716 0 0012 21.75a9.716 9.716 0 006.685-2.653zm-12.54-1.285A7.486 7.486 0 0112 15a7.486 7.486 0 015.855 2.812A8.224 8.224 0 0112 20.25a8.224 8.224 0 01-5.855-2.438zM15.75 9a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z"
                  clipRule="evenodd"
                />
              </svg>
            </label>
            <ul
              tabIndex={0}
              className="dropdown-content z-[1] menu p-2 shadow bg-base-100 rounded-box w-52"
            >
              {dropdown.map(({ key, label, to }) => (
                <li key={key}>
                  <a href={to}>{label}</a>
                </li>
              ))}
            </ul>
          </div>
        )}
        {info && !dropdown && (
          <button
            className="btn btn-circle mix-blend-color-dodge hidden md:flex"
            onClick={() => navigate("/signout")}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="w-6 h-6 text-primary"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15m3 0l3-3m0 0l-3-3m3 3H9"
              />
            </svg>
          </button>
        )}
      </div>
    </div>
  );
};

export default Navbar;
